<template>
  <v-app-bar 
    app 
    clipped-left 
    height="91"
    class="roma-app-bar d-flex align-items-center">
    <!-- desktop 
    <v-app-bar-nav-icon
      @click.stop="dpDrawer()"
      class="ml-2 mr-3 ml-md-2 mr-md-3 d-none d-lg-block"
    ></v-app-bar-nav-icon>
    -->
    <!-- mobile -->
    <v-app-bar-nav-icon
      @click.stop="dpTemporary()"
      class="ml-2 mr-3 ml-md-2 mr-md-3 sidebar-toggler"
    ></v-app-bar-nav-icon>
    

    <!-- BrandLogo 
    <router-link
      :to="{ name: 'Lesson' }"
      class="brand-logo  ml-5 mr-12"
    >
      <img src="@/assets/images/logo-roma.svg" class="" alt="" />
    </router-link>
    -->



      <!-- information 
    <div class="user align-center">
        <template v-if="user.institutionContext">
            <div class="user__icon">
                <v-img
                    :src="
                        `https://plataforma.romacl.com/LogoInstitucion?id=${user.institutionContext.identificationCode}`
                    "
                    :lazy-src="
                        `https://plataforma.romacl.com/LogoInstitucion?id=${user.institutionContext.identificationCode}`
                    "
                    width="30px"
                ></v-img>
            </div>

            <div class="user__information d-none d-md-inline">
                <p clasS="user__name text-uppercase ">
                    {{
                        user.institutionContext.identificationCode
                    }}-{{ user.institutionContext.name }}
                </p>
                <p
                    class="user__period cardTitle--text text-uppercase"
                >
                    AÑO ESCOLAR
                    {{ user.institutionContext.yearSelected }}
                </p>
            </div>
        </template>
    </div>
    -->

    <!-- mobile spacer -->
    <v-spacer class="order-2"></v-spacer>

    <div class="d-flex align-items-center order-3">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-avatar 
            v-bind="attrs"
            v-on="on"
            color="orange" 
            size="40"
          >
            <img src="@/assets/images/placeholder_avatar.png" />
          </v-avatar>
        </template>
      </v-menu>
      <div class="ml-2 align-center">
        <div class="user__information d-none d-sm-flex flex-column">
          <p class=" mr-2 titulo-5 font-inter">{{ textCapitalize(nameFormat(user.fullName)) }}</p>
          <span class="font-inter parrafo-2">
            {{ user.section.abbreviation }}
          </span>
        </div>
      </div>
      <template>
        <div class="text-center">
          <v-menu offset-y v-model="dropdownOpen">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="black" class="mr-2" v-if="!dropdownOpen">mdi-chevron-down</v-icon>
                <v-icon color="black" class="mr-2" v-else>mdi-chevron-up</v-icon>
              </v-btn>
            </template>
            <v-list>
            <v-list-item
                v-for="(item, index) in userMenuOptions"
                :key="index"
                link
                @click="item.action"
            >
                <v-list-item-title class="font-inter parrafo-2 color-neutro-0">{{ item.title }}</v-list-item-title>
            </v-list-item>
        </v-list>
          </v-menu>
        </div>
      </template>
        
    </div>
  </v-app-bar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    dpDrawer: {
      type: Function,
    },
    dpTemporary: {
      type: Function,
    },
  },
  data() {
    return {
      dropdownOpen: false,
      userMenuOptions: [
        {
          icon: "mdi-location-exit",
          title: "Cerrar sesión",
          action: () => {
            this.actionLogout();
            localStorage.clear();
            window.location = process.env.VUE_APP_ROMA_LOGOUT_CAS;
          }
        }
      ]
    }
  },
  methods: {
    ...mapActions({
      toggleDrawer: "toggleDrawer",
      actionLogout: "actionLogout"
    }),
    nameFormat(value){
      if(value){
        const lastNames = value.split(',')[0];
        const names = value.split(',')[1];
        const firstLastName = lastNames.split(' ')[0];
        const firstName = names.length > 2 ? names.trim().split(' ')[0]: '';
        return firstLastName + ' ' + firstName;
      }
    },
    textCapitalize(value){
      if(value){
        let aux = value.trim().split(' ');
        aux = aux.filter( element => element != '');
        aux = aux.map( (word, index) => {
          word = word.trim();
          return word[0].toUpperCase() + word.slice(1).toLowerCase();
        })
        return aux.join(' ');
      }
    }
  },
  computed: {
    ...mapGetters({
      user: "getUserData",
    }),
  },
};
</script>

<style lang="scss">
@import '../../assets/styles/generals.scss';
.roma-app-bar {
  z-index: 100;
  background: white !important;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1) !important;
  .v-toolbar__content {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .user {
    &__name,
    &__period {
      font-size: 15px;
    }
  }
  .roma-toolbar-title.roma-toolbar-title {
    font-size: 27px;
    color: #262626;
  }
  .brand-logo {
    // width: 175px;
    height: 40px;
    img {
      width: auto;
      height: 100%;
    }
  }
  &__avatar {
    margin-left: 70px;
  }

  @media (min-width: 1904px) {
    .v-toolbar__content {
      height: 92px;
    }
    .user {
      &__name,
      &__period {
        font-size: 16px;
      }
    }
    .roma-toolbar-title.roma-toolbar-title {
      font-size: 27px;
    }
    .brand-logo {
      height: 40px;
    }
    &__avatar {
      height: 52px !important;
      min-width: 52px !important;
      width: 52px !important;
    }
  }
  @media (min-width: 1264px) and (max-width: 1903px) {
    .v-toolbar__content {
      height: 79px;
    }
    .user {
      &__name,
      &__period {
        font-size: 15px;
      }
    }
    .roma-toolbar-title.roma-toolbar-title {
      font-size: 23px;
    }
    .brand-logo {
      height: 23px;
    }
    &__avatar {
      height: 45px !important;
      min-width: 45px !important;
      width: 45px !important;
    }
  }
  @media (min-width: 960px) and (max-width: 1263px) {
    .v-toolbar__content {
      height: 61px;
    }
    .user {
      &__name,
      &__period {
        font-size: 9px;
      }
    }
    .roma-toolbar-title.roma-toolbar-title {
      font-size: 17px;
    }
    .brand-logo {
      height: 18px;
    }
    &__avatar {
      height: 35px !important;
      min-width: 35px !important;
      width: 35px !important;
    }
  }
  @media (min-width: 600px) and (max-width: 959px) {
    .v-toolbar__content {
      height: 58px;
    }
    .roma-toolbar-title.roma-toolbar-title {
      font-size: 15px;
    }
    .brand-logo {
      height: 18px;
    }
    &__avatar {
      height: 27px !important;
      min-width: 27px !important;
      width: 27px !important;
    }
  }
}
@media (max-width: 720px) {
  .roma-app-bar{
    height: 58px !important;
  }
  .v-toolbar__content {
    height: 58px;
  }
  .roma-toolbar-title.roma-toolbar-title {
    font-size: 15px;
  }
  .brand-logo {
    height: 22px;
  }
}
</style>
